var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.7561 5.24408C18.0815 5.56951 18.0815 6.09715 17.7561 6.42259L9.42275 14.7559C9.09731 15.0814 8.56968 15.0814 8.24424 14.7559L4.07757 10.5893C3.75214 10.2638 3.75214 9.73618 4.07757 9.41074C4.40301 9.08531 4.93065 9.08531 5.25609 9.41074L8.8335 12.9882L16.5776 5.24408C16.903 4.91864 17.4306 4.91864 17.7561 5.24408Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheck);
export default __webpack_public_path__ + "static/media/check.cf1db1a606850fb11c6b78c4e210b382.svg";
export { ForwardRef as ReactComponent };